export enum PaymentStatusEnum{
    PAID  = 'PAID',
    NOT_PAID  = 'NOT PAID'
}
export enum PayablePaymentStatusEnum{
    PAID  = 'PAID',
    PARTIALLY_PAID  = 'PARTIALLY PAID',
    OPEN='OPEN'
}